import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 * @param {String} baseURL
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({});

    const completePaymentTask = (ticketId) => api.put(ApiPaths.COMPLETE_PAYMENT(ticketId), null);

    // Return back a collection of functions
    return { completePaymentTask }
}

// let's return back our create method as the default.
export default {
    create
}
